import { Component, DestroyRef, OnInit } from '@angular/core';
import { DashboardService } from '@app/dashboard/services/dashboard.service';
import { map } from 'rxjs/operators';
import { ToArabicPipe } from '@app/shared/pipes/toArabic.pipe';
import { SHARED_IMPORTS } from '@app/shared/shared.imports';
import { ApiResponse } from '@app/interfaces';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-dashboard-footer',
  templateUrl: './dashboard-footer.component.html',
  styleUrls: ['./dashboard-footer.component.scss'],
  standalone: true,
  imports: [...SHARED_IMPORTS]
})
export class DashboardFooterComponent implements OnInit {
  items: {
    icon: string;
    firstLine: string;
    secondLine: string;
    count: string | number;
  }[] = [];
  loaded: boolean;
  constructor(private service: DashboardService, private toArabic: ToArabicPipe, private destroyRef: DestroyRef) {
    this.items = [
      {
        icon: 'delivery-truck-gray',
        firstLine: 'footer.unitsFirstLine',
        secondLine: 'footer.unitsSecondLine',
        count: ''
      },
      {
        icon: 'weight-footer',
        firstLine: 'footer.weightFirstLine',
        secondLine: 'footer.weightSecondLine',
        count: ''
      }
    ];
  }
  getData() {
    this.service
      .getData('total-system-info')
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((row: ApiResponse) => row.data)
      )
      .subscribe((response: { total_system_units: string | number; total_system_weights: string | number }) => {
        if (response) {
          console.log(response);
          this.items[0]['count'] = response['total_system_units'];
          this.items[1]['count'] = response['total_system_weights'];
          this.loaded = true;
        }
      });
  }

  // refactorResponse(data: { total_system_units: string | number; total_system_weights: string | number }) {
  //   if (data && data['total_system_units'] && data['total_system_weights']) {
  //     data['total_system_units'] = this.toArabic.transform(data['total_system_units'].toString());
  //     data['total_system_weights'] = this.toArabic.transform(data['total_system_weights'].toString());
  //     return data;
  //   }
  // }

  ngOnInit() {
    this.getData();
  }
}
